import React, { useContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import { defaultVideoConfig } from './VideoConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const initialLocation = {
  routes: [],
  paths: {}
};
const initialState = {
  config: defaultVideoConfig,
  appLocation: initialLocation,
  initialData: {
    topics: []
  }
};
export const AppStateContext = /*#__PURE__*/React.createContext(initialState);
export const VideoAppProvider = ({
  config,
  initialData,
  appLocation,
  i18n,
  errorState,
  children
}) => /*#__PURE__*/_jsx(I18nextProvider, {
  i18n: i18n,
  children: /*#__PURE__*/_jsx(AppStateContext.Provider, {
    value: {
      config,
      initialData,
      appLocation,
      errorState
    },
    children: children
  })
});
export const useVideoConfig = () => {
  const {
    config
  } = useContext(AppStateContext);
  if (config === undefined) {
    throw new Error('useVideoConfig must be used within a VideoAppProvider');
  }
  return config;
};
export const useErrorState = () => useContext(AppStateContext).errorState;
export const usePath = () => {
  const {
    appLocation: {
      paths
    }
  } = useContext(AppStateContext);
  if (paths === undefined) {
    throw new Error('usePath must be used within a VideoAppProvider');
  }
  return paths;
};
export const useRoutes = () => {
  const {
    appLocation: {
      routes
    }
  } = useContext(AppStateContext);
  if (routes === undefined) {
    throw new Error('useRoutes must be used within a VideoAppProvider');
  }
  return routes;
};
export const useInitialData = () => {
  const {
    initialData
  } = useContext(AppStateContext);
  if (initialData === undefined) {
    throw new Error('useInitialData must be used within a VideoAppProvider');
  }
  return initialData;
};